angular.module('common').factory('Label', ['resourceFactory', function(resourceFactory) {
  return resourceFactory('/api/labels', {});
}]);
